import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Вмъкваме JSON файловете
import translationBG from './locales/bg.json';
import translationEN from './locales/en.json';

const resources = {
  bg: { translation: translationBG },
  en: { translation: translationEN }
};

i18n
  .use(LanguageDetector) // Автоматично засича езика
  .use(initReactI18next) // Свързва се с React
  .init({
    resources,
    fallbackLng: 'bg', // Език по подразбиране
    interpolation: {
      escapeValue: false // React вече ни пази от XSS
    }
  });

export default i18n;